/*
*###############################################################################
*Module Name                   : VoucherGroupControl.js                        #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Monday, September 27th 2021, 1:19:48 pm       #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
// Voucher Group save method
  const setVoucherGroupSave = async (
    strVoucherCode,
    strVoucherDesc,
    dbSellValue,
    dbValidDaysValue,
    dbPrintCostValue,
    dbNumberOfVouchersValue,
    strBookNumberValue,
    IsActive,
    blEditableStatus,
    blRandomStatus,
    strCreateBy,
    strMenuCode,
    strLoggedCompany,
    strLoggedLocation,
    strReason,
    blAddNew
  ) => {
    var myHeaders = new Headers()
    const authToken = localStorage.getItem("authToken")
    myHeaders.append("Content-Type", "application/json")
    myHeaders.append("Authorization", `Bearer ${authToken}`)
  
    var raw = JSON.stringify({
        strCode: strVoucherCode,
        strName: strVoucherDesc,
        strStatus: IsActive,
        dbValue: dbSellValue,
        intEdit: blEditableStatus,
        dbExpairdate: dbValidDaysValue,
        intRand: blRandomStatus,
        dbCost: dbPrintCostValue,
        dbBookQty: dbNumberOfVouchersValue,
        dbBookNo: strBookNumberValue,
        strCreateBy:strCreateBy,
        strMenuCode:strMenuCode,
        strLoggedCompany:strLoggedCompany,
        strLoggedLocation:strLoggedLocation,
        strReason:strReason,
        blAddNew:blAddNew
    })

    console.log(raw)
    console.log("")

    const ApiURL = window.Links.ApiURL
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    }

    var data = [];
    await fetch(`${ApiURL}VoucherGroup`, requestOptions)
        .then(response => data = response)
        .catch(error => console.log('error', error))
    return data;
  
  
  }
  // Voucher Group code search
  const getVoucherGroupSearch = async id => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = []
    var requestOptions = {
      method: "GET",
      headers: { 
        "Authorization": `Bearer ${authToken}`
     },
      redirect: "follow",
    }
    await fetch(`${ApiURL}VoucherGroup/search/${id}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        data = result.data
      })
      .catch(error => console.log("error", error))
    return data
  }
  // Voucher Group  search for main popup

  const getVoucherGroupSummary = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var data = []
    var requestOptions = {
      method: "GET",
      headers: { 
        "Authorization": `Bearer ${authToken}`
     },
      redirect: "follow",
    }
    await fetch(`${ApiURL}VoucherGroup/`, requestOptions)
      .then(response => response.json())
      .then(result => {
        data = result.data
      })
      .catch(error => console.log("error", error))
    return data
  }

  export {
  setVoucherGroupSave,
  getVoucherGroupSearch,
  getVoucherGroupSummary

  }
  